const LabelInput = ({ className, value, status }) => {
  return (
    <label className={`${className}`}>
      {value} {status && <span className="ml-2 monkey-color-red">*</span>}
    </label>
  );
};
export default LabelInput;
